import { reduce } from 'lodash';
import { map } from 'lodash/collection';
import { get } from 'lodash/object';

import { COMMENT_FIELD_IS_NOT_AVAILABLE, ITEM_ALREADY_EXISTS } from '../../../../constants/notificationMessages';
import { caseInsensitiveStringEquals } from '../../../../services/string';

export function getAllOptionalItems(allInputs, onlyCheckedItems) {
  const optionalItems = get(allInputs, '[0].optional[0].itemDefinitionList', []);
  return onlyCheckedItems ? optionalItems.filter(e => e.isChecked) : optionalItems;
}

export function getAllCustomItems(allInputs) {
  return map(get(allInputs, '[0].custom', []), 'customItemDefinationList[0]');
}

export function validateQuestions(allInputs) {
  const allOptionalQuestions = getAllOptionalItems(allInputs, false);
  const allCustomQuestions = getAllCustomItems(allInputs);
  return validateQuestionsName([...allOptionalQuestions, ...allCustomQuestions]);
}

export function validateQuestionsName(allQuestions) {
  const object = reduce(
    allQuestions,
    function(accumulator, item) {
      const resolvedName = item.updatedQuestion || item.question || item.name;
      if (!accumulator.uniqueNames.some(uniqueName => caseInsensitiveStringEquals(uniqueName, resolvedName))) {
        accumulator.uniqueNames.push(resolvedName);
      } else {
        accumulator.errors.duplicates.push(resolvedName);
      }
      if (caseInsensitiveStringEquals('Comment', resolvedName)) {
        accumulator.errors.commentAlreadyExist = true;
      }
      return accumulator;
    },
    { uniqueNames: [], errors: { duplicates: [], commentAlreadyExist: false } }
  );
  if (object.errors.commentAlreadyExist) {
    return COMMENT_FIELD_IS_NOT_AVAILABLE;
  }
  if (object.errors.duplicates.length) {
    return `${ITEM_ALREADY_EXISTS}: ${object.errors.duplicates.join(', ')}`;
  }
  return null;
}

export function validateQuestion(allInputs, questionName, rejectPredicate) {
  const allOptionalQuestions = getAllOptionalItems(allInputs, false);
  const allCustomQuestions = getAllCustomItems(allInputs);
  return validateQuestionName([...allOptionalQuestions, ...allCustomQuestions], questionName, rejectPredicate);
}

export function validateQuestionName(allQuestions, fieldName, rejectPredicate) {
  if (caseInsensitiveStringEquals('Comment', fieldName)) {
    return COMMENT_FIELD_IS_NOT_AVAILABLE;
  }
  const uniqueNames = reduce(
    allQuestions,
    function(accumulator, item) {
      if (rejectPredicate && rejectPredicate(item)) {
        return accumulator;
      }
      const resolvedName = item.updatedQuestion || item.question || item.name;
      if (!accumulator.some(uniqueName => caseInsensitiveStringEquals(uniqueName, resolvedName))) {
        accumulator.push(resolvedName);
      }
      return accumulator;
    },
    []
  );
  if (uniqueNames.some(uniqueName => caseInsensitiveStringEquals(uniqueName, fieldName))) {
    return ITEM_ALREADY_EXISTS;
  }
  return null;
}
